import {
    ApplicationStartStep,
    AwardsStep,
    BioStep,
    BrandsStep,
    DisciplineSkillsStep,
    EducationStep,
    IndustriesStep,
    InfoStep,
    LinksDocumentsStep,
    ProjectInterestsStep,
    RecommendedSkillsStep,
    ReferencesStep,
    ReviewStep,
    VideoInterviewStep,
    WorkHistoryStep,
    WorkSamplesStep,
    AIExperienceStep,
} from "../../views/talent-application/steps"
import User from "../User";
import TalentSkill from "../TalentSkill";
import TalentAdminOppList from "../../views/admin/TalentManagerOppList";
import TalentManagerUsersList from "../../views/admin/TalentManagerUsersList";
import TalentDashboard from "../../views/talent-dashboard/TalentDashboard";
import ProfileEdit from "../../views/talent-portal/ProfileEdit";
import OppList from "../../views/talent-opportunities/OppList";
import Document from "../Document";
import ProjectPosition from "../ProjectPosition";
import TalentJobBoard from "../../views/talent-job-board/TalentJobBoard";
import JobDetails from "../../views/talent-job-board/JobDetails";
import Opportunity from "../Opportunity";
import AgencyOpportunity from "../AgencyOpportunity";
import {Exception} from "sass";
import CertificationStep from "../../views/talent-application/steps/CertificationsStep";
import WorkPreferencesStep from "../../views/talent-application/steps/WorkPreferencesStep";
import AvailabilityStatusStep from "../../views/talent-application/steps/AvailabilityStatusStep";
import Auth from "../../Auth";


const HasTalentTraits = WrappedClass => {
    return class HasTalentApplication extends WrappedClass {

        /*
        |--------------------------------------------------------------------------
        | Talent User Request Methods
        |--------------------------------------------------------------------------
        */

        async fetchContracts() {
            if (this.isTalent() && !this.isApplicationApproved()) {
                throw new Error('Unauthorized')
            }

            if (!this.isTalent() && !this.canManageClientResourceTalent()) {
                throw new Error('Unauthorized')
            }

            User.FetchTalentContractsRequest = TB.request(
                TB.api_endpoint(`/api/talent/contracts`)
            );

            let response = await User.FetchTalentContractsRequest.get().catch(console.warn);

            if (!response
                || !response.success
                || !response.success.data
                || !response.success.data.opportunities) {
                return;
            }

            let responseData = {...response.success.data};

            if (!responseData.platform) {
                responseData.platform = {};
            }

            return responseData;
        }

        static FetchTalentRecommendedSkillsRequest;

        async fetchTalentRecommendedSkills() {
            let auth = TB.auth()?.user();

            if (!this.isTalent()) {
                return;
            }

            if (auth?.id !== this.id && !auth.canManageClientResourceTalent()) {
                return
            }
            User.cancelRequest('FetchTalentRecommendedSkillsRequest');

            User.FetchTalentRecommendedSkillsRequest = TB.request(
                TB.api_endpoint(`/api/talent-skills/recommended`),
                auth.canManageClientResourceTalent?.() ? {talent_user_id: this.id} : null
            );

            let response = await User.FetchTalentRecommendedSkillsRequest.get().catch(console.warn);

            if (!TB.has(response, 'success.data.skills')) {
                return;
            }

            return TalentSkill.makeMany([...response.success.data.skills]);
        }

        async signMasterContract() {
            if (!this.isTalent()
                || !this.isApplicationApproved()) {
                return;
            }

            let updates = {
                agreement_signed_at: TB.moment().utc().format(
                    'YYYY-MM-DD HH:mm:ss'
                )
            }

            return TB.auth().talentUpdate(updates).catch(console.warn);
        }

        // async fetchProjects()
        // {
        //     if (!this.isTalent()
        //         || !this.isApplicationApproved()) {
        //         return;
        //     }

        //     User.FetchAllForClientRequest = TB.request(
        //         TB.api_endpoint(`/api/talent/contracts`)
        //     );

        //     let response = await User.FetchTalentContractsRequest.get().catch(console.warn);

        //     if (!response
        //         || !response.success
        //         || !response.success.data
        //         || !response.success.data.projects)
        //     {
        //         return;
        //     }

        //     let responseData = {...response.success.data};

        //     if (!responseData.platform) {
        //         responseData.platform = {};
        //     }

        //     return responseData;
        // }

        /*
        |--------------------------------------------------------------------------
        | Talent User Opportunity Methods
        |--------------------------------------------------------------------------
        */

        // opportunitiesByStatus() {

        //     let projects = Opportunity.makeMany(TB.tryArray(this.projects));

        //     let activeProjects = TB.orderBy(projects, 'created_at', 'desc');

        //     return TB.groupBy(activeProjects, 'status');
        // }

        // availableContracts()
        // {
        //     let projectsWithContract = TB.reject(TB.tryArray(this.projects), ['contract', null]);

        //     return TB.map(projectsWithContract, opp => {
        //         let contract = {...opp.contract};

        //         if (!contract.name && opp.project) {
        //             contract.name = opp.project?.name;
        //         }

        //         return Document.make({...contract});
        //     })
        // }

        /*
        |--------------------------------------------------------------------------
        | Talent User Profile Methods
        |--------------------------------------------------------------------------
        */

        isTalentManager() {
            return this.type === laravel.user_types.talent_manager;
        }

        isTalent() {
            return this.type === laravel.user_types.talent;
        }

        fullBio() {
            return this.wripple_description || this.bio
        }

        shortBio() {
            if (!this.bio && !this.wripple_description) {
                return;
            }

            if (this.wripple_description) {
                return this.wripple_description.substr(0, 64);
            }

            return this.bio.substr(0, 64);
        }

        isActive() {
            return this.isApplicationApproved()
                && !this.isApplicationRejected()
                && this.didSignAgreement()
        }

        isApplicationApproved() {
            return TB.isDefined(this.approved_at) && !this.isApplicationRejected();
        }

        isApplicationRejected() {
            return TB.isDefined(this.rejected_at);
        }

        isProfileApproved() {
            return TB.isDefined(this.talent_profile_approved_at);
        }

        isPendingProfileApproved() {
            return this.isApplicationApproved() && !this.isProfileApproved() && !this.isProfileRejected() && this.talent_profile_review_requested_at;
        }

        isProfileRejected() {
            return TB.isDefined(this.talent_profile_rejected_at);
        }

        mustSignAgreement() {
            return this.isApplicationApproved() &&
                laravel.talent_agreement_available &&
                !this.didSignAgreement();
        }

        didSignAgreement() {
            return !laravel.talent_agreement_available || TB.isDefined(this.agreement_signed_at);
        }

        isBeingReviewed() {

            // console.log('isBeingReviewed',this.didSubmitApplication())

            return this.didSubmitApplication()
                && !this.isApplicationApproved()
                && !this.isApplicationRejected();
        }

        /*
        * Application Helper Methods
        */
        didSubmitApplication() {
            return TB.isDefined(this.applied_at);
        }

        disabledPanelMessageForContracts() {

            if (this.mustSignAgreement()) {
                return TB.trans('talent.has_talent_traits.contracting_false_msg')
            }

            return this.disabledPanelMessageForProjects();
        }

        disabledPanelMessageForProjects() {
            if (this.didSignAgreement()) {
                return false;
            }
            return TB.trans('talent.has_talent_traits.availability_false_msg')
        }

        disabledPanelMessageForProfile() {
            // if (this.didSignAgreement()) {
            return false;
            // }

            // return TB.trans('talent.has_talent_traits.profile_false_msg')
        }

        availabilityByWeek() {
            if (!this.work_schedule_weeks) {
                return [];
            }

            let schedule = [];

            for (let [week, hours] of Object.entries(this.work_schedule_weeks)) {

                schedule.push({
                    start: TB.moment(week).startOf('week'),
                    end: TB.moment(week).endOf('week'),
                    hours: hours
                })
            }

            return schedule;
        }

        /*
        |--------------------------------------------------------------------------
        | Talent User Portal
        |--------------------------------------------------------------------------
        */

        portalPages() {
            if (this.canManageTalent()) {
                return [
                    TalentAdminOppList,
                    TalentManagerUsersList
                ]
            } else if (!this.isTalent()) {
                return []
            }


            return [
                TalentDashboard,
                JobDetails,
                ProfileEdit,
                OppList,
                // ContractsList,
                TalentJobBoard
            ]
        }

        /*
       |--------------------------------------------------------------------------
       | Talent User Profile Steps
       |--------------------------------------------------------------------------
       */

        static TalentApplicationSteps = [
            ApplicationStartStep,
            InfoStep,
            BioStep,
            ReferencesStep,
            DisciplineSkillsStep,
            AIExperienceStep,
            ProjectInterestsStep,
            RecommendedSkillsStep,
            IndustriesStep,
            WorkPreferencesStep,
            VideoInterviewStep,
            ReviewStep,
        ];

        static TalentFullProfileSteps = [
            InfoStep,
            BioStep,
            VideoInterviewStep,
            ReferencesStep,
            DisciplineSkillsStep,
            AIExperienceStep,
            RecommendedSkillsStep,
            IndustriesStep,
            ProjectInterestsStep,
            AvailabilityStatusStep,
            WorkPreferencesStep,
            BrandsStep,
            WorkSamplesStep,
            WorkHistoryStep,
            EducationStep,
            CertificationStep,
            AwardsStep
        ]
        getApplicationStepsForTalent() {
            if (this.isTalentSupplierResource()) {
                return TB.filter(this.constructor.TalentApplicationSteps, profileStep => profileStep !== WorkPreferencesStep);
            }
            return this.constructor.TalentApplicationSteps;
        }
        getFullProfileStepsForTalent() {
            if (this.isTalentSupplierResource()) {
                return TB.filter(this.constructor.TalentFullProfileSteps, profileStep => profileStep !== AvailabilityStatusStep
                    && profileStep !== WorkPreferencesStep);
            }
            return this.constructor.TalentFullProfileSteps;
        }
        currentProfileSteps() {
            let steps = [...this.getApplicationStepsForTalent()];

            if (!this.isApplicationApproved()) {
                return steps
            }

            return this.getFullProfileStepsForTalent();
        }


        hasCompletedApplication = TB.memoize(this.checkApplicationCompletion.bind(this));

        checkApplicationCompletion() {

            let firstSteps = [...TB.filter([...this.getApplicationStepsForTalent()], 'StepInfo')];

            if (this.isApplicationApproved()) {
                return true
            }
            for (let step of firstSteps) {
                if (step.StepNeedsValidation(this)) return false;
            }

            return true
        }

        hasCompletedProfile = TB.memoize(this.checkProfileCompletion.bind(this));

        checkProfileCompletion() {

            if (!this.isApplicationApproved()) {
                return false;
            }
            let steps = [...this.getFullProfileStepsForTalent()];

            steps.pop();

            steps = steps.reverse();


            for (let step of steps) {
                if (step.StepNeedsValidation(this)) return false;
            }

            return true
        }

        remainingProfileSections() {
            let steps = this.currentProfileSteps(), lastStep = this.lastStepRemaining();

            return steps.length - (steps.indexOf(lastStep))
        }

        lastStepRemaining() {

            let steps = this.currentProfileSteps();

            for (let step of steps) {
                if (step.StepNeedsValidation(this)) return step;
            }

            return false
        }


        profileProgress() {
            let allSteps = this.currentProfileSteps();
            let stepsRemaining = TB.filter([...this.currentProfileSteps()], step => !step.NeedsCompletion?.(this) || step.hasCompleted(this));

            return TB.ceil((stepsRemaining.length / allSteps.length) * 100)
            // return this.constructor.progressForStep(lastStepRemaining, this.isApplicationApproved())
        }

        currentApplicationStep() {

            let lastSavedStep = this.lastStepRemaining();

            if (lastSavedStep) return lastSavedStep;

            return this.isApplicationApproved() ? InfoStep : ApplicationStartStep;
        }


        static progressForStep(currentStep = ApplicationStartStep, isApproved = false) {

            if (!isApproved) {
                switch (currentStep) {
                    case ApplicationStartStep:
                    case InfoStep:
                        return 10
                    case BioStep:
                        return 20
                    case DisciplineSkillsStep:
                        return 30
                    case AIExperienceStep:
                        return 40
                    case ProjectInterestsStep:
                        return 50
                    case RecommendedSkillsStep:
                        return 60
                    case IndustriesStep:
                        return 70
                    case WorkPreferencesStep:
                        return 80
                    case VideoInterviewStep:
                        return 90
                    case ReviewStep:
                    default:
                        return 100
                }
            }

            switch (currentStep) {
                case InfoStep:
                    return 10
                case BioStep:
                    return 20
                case DisciplineSkillsStep:
                    return 30
                case AIExperienceStep:
                    return 35
                case ProjectInterestsStep:
                    return 40
                case WorkPreferencesStep:
                    return 45
                case AvailabilityStatusStep:
                    return 47
                case RecommendedSkillsStep:
                    return 50

                case IndustriesStep:
                    return 60
                case LinksDocumentsStep:
                    return 70
                case EducationStep:
                    return 75
                case WorkHistoryStep:
                    return 80
                case ReferencesStep:
                    return 83
                case BrandsStep:
                    return 85
                case WorkSamplesStep:
                    return 90
                case AwardsStep:
                    return 95
                case VideoInterviewStep:
                    return 98
                default:
                    return 100
            }
        }

        fieldInvalidate(field) {
            return !TB.isDefined(this[field]) || TB.isNaN(this[field] ||
                (typeof this[field] === 'string' && !this[field].length))
        }


        /**
         * Return any invalid fields as an array of error messages,
         *
         * @param item
         * @param type
         * @returns Array|boolean
         */
        static profileItemInvalidate(item, type) {
            let invalid = [];

            let requiredFields = [];
            switch (type) {
                case 'jobs':
                    requiredFields = this.jobValidationRules();
                    break;
                case 'schools':
                    requiredFields = this.schoolValidationRules();
                    break;
                case 'certifications':
                    requiredFields = this.certificationValidationRules();
                    break;
                case 'awards':
                    requiredFields = this.awardValidationRules();
                    break;
            }

            TB.map(requiredFields, (message, field) => {
                // Turn rules into array
                // let rules = TB.split(validationRules, '|');

                // if (!rule.length) return false;
                // console.log(type, field, item[field]);
                if (!TB.isDefined(item[field])) {
                    invalid.push(message)
                }
            })

            return invalid;
        }

        videoInterviewsArePublic() {
            return this.talent_video_interviews?.length > 0 &&
                !TB.find(this?.talent_video_interviews, ['is_public', false])
        }
        creativeRolesAdded() {
            const requiredDisciplines = [
                'Copy Writer','Copywriter', 'Graphic Designer', 'Creative Director', 'Content Creator', 'Production Designer',
                'Art Director', 'Email Designer & Developer', 'Photographer', 'Video Producer', 'Videographer', 'Video Editor',
                'VO Talent', 'Motion Graphics Artist', 'Animation Designer', 'NFT Creator/Artist', 'Visual & UI Designer',
                'User Experience Designer', 'Web Designer', 'Community Manager', 'Social Media Manager', 'Social Media Strategist',
                'Corporate Communications Specialist'
            ]
            let disciplinesMatching = TB.filter(this.talent_disciplines || [], discipline => requiredDisciplines.includes(discipline.name));

            return TB.filter(disciplinesMatching, discipline => !discipline.is_rejected)
        }
        shouldRequirePortfolioLink() {
           return this.isTalent() && !this.isTalentSupplierResource() && this.creativeRolesAdded().length > 0
        }

        validateInfo() {

            let fields = [
                'first_name', 'last_name', 'email',
                'location', 'phone',
                'primary_language', 'english_level',
                'resume_path'
                // 'available_hours_per_week',
            ]


            if (!this.isTalentSupplierResource()) {
                fields.push('available_hours_per_week', 'referred_by', 'min_hourly_rate', 'ideal_hourly_rate');
            }

            if (!this.isTalentSupplierResource() && this.is_business) {
                fields.push('business_name', 'business_type');
            }

            if (this.isClientInvitedResource()) {
                fields.push('is_on_talent_marketplace');
            }

            let undefinedFields = TB.filter(fields, field => this.fieldInvalidate(field))

            fields.push('referred_by_name');

            if (undefinedFields.length > 0) {
                return false;
            }

            fields.push('race', 'ethnicity', 'preferred_pronoun', 'gender');

            let infoFields = TB.pick(this, fields);

            if (!this.isTalentSupplierResource()) {
                infoFields.spoke_with_employee_named = this.has_spoken_with_wripple ? this.spoke_with_employee_named : ''
            }

            if (TB.isNaN(fields.ethnicity)) fields.ethnicity = undefined;

            if (TB.isNaN(fields.race)) fields.race = undefined;

            if (TB.isNaN(fields.gender)) fields.gender = undefined;

            if (TB.isNaN(fields.preferred_pronoun)) fields.preferred_pronoun = undefined;

            if (TB.isDefined(this.ethnicity_option) && !TB.isNaN(this.ethnicity_option)) {
                infoFields.ethnicity = this.ethnicity_option;
            }

            if (TB.isDefined(this.race_option) && !TB.isNaN(this.race_option)) {
                infoFields.race = this.race_option;
            }
            if (this.resume_path) {
                infoFields.resume_path = this.resume_path;
            }else {
                infoFields.resume_path = false;
            }
            return infoFields;
        }

        validateBio() {
            let fields = [
                'bio', 'job_title', 'years_of_experience', 'image_path', 'linkedin_profile_url',
                'can_travel_for_work',
            ];


            // if (this.can_travel_for_work) {
            //     fields.push('max_travel_distance', 'travel_days_per_week', 'max_travel_distance_units')
            // }

            for (let field of fields) {
                if (this.fieldInvalidate(field)) {
                    return false;
                }
            }
            fields.push('portfolio_url','profile_links','profile_documents');

            let updates = TB.pick(this, [...fields]);


            if (!updates.profile_links?.length) {
                updates.profile_links = [];
            }else {
                updates.profile_links = TB.filter(updates.profile_links, link => !!link.id || link.type);
                updates.profile_links = TB.map(updates.profile_links, link => {
                    return TB.pick(link, ['id','type', 'url', 'username', 'password', 'display_index'])
                })
            }

            // Validate and transform docs
            if (!updates.profile_documents?.length) {
                updates.profile_documents = [];
            }else {
                updates.profile_documents = TB.map(updates.profile_documents, doc => {
                    let type = TB.isNaN(parseInt(doc.type)) ? doc.type_id : doc.type;
                    if (!type) {
                        type = TB.invert(laravel.talent_profile_document_types)['Miscellaneous'] ||
                        TB.first(TB.invert(laravel.talent_profile_document_types));

                    }
                    return {
                        id: doc.id,
                        name: doc.name,
                        path: doc.path,
                        type,
                        display_index: doc.display_index,
                    }
                })
            }


            if (this.resume_path) {
                updates.resume_path = this.resume_path;
            }else {
                updates.resume_path = false;
            }
            return updates
        }

        validateAvailabilityStatus() {
            let fields = [
                'can_travel_for_work',
                'available_hours_per_week',
                'has_full_time_employment_interest',
                // 'has_contract_to_hire_interest',
                'can_travel_for_work',
            ]
            if(this.isOnTalentMarketplace()) {
                fields.push('is_available', 'talent_commitment_level',)
            }

            if (this.can_travel_for_work) {
                fields.push('max_travel_distance', 'travel_days_per_week', 'max_travel_distance_units')
            }
            for (let field of fields) {
                if (this.fieldInvalidate(field)) {
                    console.log('validateAvailabilityStatus', field)
                    return false;
                }
            }
            fields.push('prefers_any_non_us_timezone', 'prefers_any_timezone',)

            let workPreferenceRatings = this.constructor.TalentWorkPreferences;

            workPreferenceRatings = TB.reduce(workPreferenceRatings, (result, rating) => {
                result[rating] = parseInt(this.talent_work_preferences?.[rating]) || 1;
                return result;
            }, {})

            let allTimeZones = Object.values({...laravel.talent_questions.time_zones});

            let timeZonePrefs = [];
            for (let timeZone of allTimeZones) {
                if (this.prefers_any_timezone
                    || this.time_zones?.includes(timeZone.id)) {
                    timeZonePrefs.push(timeZone.id);
                }
            }


            let updates = TB.pick(this, [...fields]);

            return {
                ...updates,
                time_zones: timeZonePrefs,
                talent_work_preferences: {...workPreferenceRatings}
            }
        }

        validateProfileOptimizer() {
            let fields = [
                'talent_disciplines', 'skills'
            ]

            if (!this.talent_disciplines?.length) {
                return false
            }
            if (!this.skills?.length) {
                return false
            }

            if (this.shouldRequirePortfolioLink()) {
                fields.push('portfolio_url');
                if (this.portfolio_url_notes?.length) {
                    fields.push('portfolio_url_notes');
                }
            }

            for (let field of fields) {
                if (this.fieldInvalidate(field)) {
                    return false;
                }
            }

            fields = TB.pick(this, fields);

            return fields;
        }

        validateWorkPreferences() {
            // Check tax class questions
            let {
                has_w2_classification,
                has_1099_classification,
                ...settings
            } = {...(this.tax_class_settings || {} || {})};

            if (!has_w2_classification && !has_1099_classification) {
                return false;
            }

            if (has_1099_classification) {
                for (let key of TB.keys(settings || {})) {
                    if (TB.isNil(settings[key])) {
                        return false;
                    }
                }
            }
            return TB.pick(this, ['tax_class_settings'])
        }

        static ClassificationQuestionsFor1099 = {
            has_llc: 'Have you established an LLC for your freelance business?',
            has_website: 'Do you have a professional website or other materials to market your services as an independent freelancer?',
            has_multiple_clients: 'Are you currently working with, or do you plan to work with, multiple clients simultaneously?',
            has_owned_tools: 'Do you use your own equipment, tools, and methodologies to deliver your work?',
            has_no_micromanagement: 'Do you typically work independently, without needing frequent oversight from clients?',
        }

        hasW2Classification = () => {
            return this.tax_class_settings?.has_w2_classification
        }

        has1099Classification = () => {
            return this.is_1099_eligible || this.isQualifiedFor1099Classification()
        }

        incomplete1099Classification = () => {
            return this.tax_class_settings?.has_1099_classification && !this.has1099Classification()
        }

        isQualifiedFor1099Classification() {
            // Check tax class questions
            let {
                has_w2_classification,
                has_1099_classification,
                ...settings
            } = {...(this.tax_class_settings || {})};

            if (!has_1099_classification) {
                return false;
            }

            for (let key of TB.keys(this.constructor.ClassificationQuestionsFor1099)) {
                if (settings[key] !== true) {
                    console.log('isQualifiedFor1099Classification', key)
                    return false;
                }
            }
            return true;
        }

        validateAIExpertise() {
            let fields = [
                'ai_focus_level', 'ai_work_approach', 'skills',
            ]

            if (!this.ai_focus_level || (this.ai_focus_level > 1 && !this.ai_work_approach?.length)) {
                return false;
            }

            fields = TB.pick(this, fields);
            return fields;
        }

        validateDisciplineSkills() {
            let fields = [
                'talent_disciplines', 'skills', 'ai_focus_level', 'ai_work_approach',
            ]
            if (!this.talent_disciplines?.length) {
                return false
            }
            if (!this.skills?.length) {
                return false
            }

            fields = TB.pick(this, fields);

            // if (fields.skills.length) {
            //     fields.skills = TB.map(fields.skills, skill => {
            //         if (skill.self_score )
            //     })
            // }

            return fields;
        }

        validateProjectInterests() {
            let fields = [
                'project_interest'
            ]

            for (let field of fields) {
                if (this.fieldInvalidate(field)) {
                    return false;
                }
            }

            if (this.isOnTalentMarketplace() && !this.talent_service_groups?.length
                && laravel.platform_features.talent.services) {
                return false
            }

            fields.push(
                'talent_service_groups',
                'has_auto_team_matching_interest',
                'offers_byo_work'
            );

            let picked = TB.pick(this, fields);

            picked.talent_service_groups = TB.map(picked.talent_service_groups || [], service => {
                return TB.pick(service, ['id'])
            })
            picked.can_travel_for_work = picked.can_travel_for_work ? 1 : 0;
            picked.has_auto_team_matching_interest = picked.has_auto_team_matching_interest ? 1 : 0;
            picked.offers_byo_work = picked.offers_byo_work ? 1 : 0;

            return picked;
        }

        validateIndustries() {
            if (!this.industries_worked?.length) {
                return false
            }

            return TB.pick(this, ['industries_worked']);
        }
        validateBrands() {


            return TB.pick(this, ['brands']);
        }

        validateTalentReferences() {

            if (this.isOnTalentMarketplace() && !this.isTalentSupplierResource() && this.talent_references?.length <= 1) {
                return false
            }
            return TB.pick(this, ['talent_references']);
        }

        validateReview() {
            if (!this.applied_at) {
                return false
            }

            return TB.pick(this, 'applied_at');
        }

        validateLinksDocuments() {
            // if (!this.profile_links?.length && !this.profile_documents?.length) {
            //     return false
            // }

            let input = TB.pick(this, ['profile_links', 'profile_documents']);
            if (!input.profile_links) {
                input.profile_links = [];
            }
            if (!input.profile_documents) {
                input.profile_documents = [];
            }

            return input;
        }

        validateCertifications() {


            let input = TB.pick(this, ['certifications']);

            if (!input.certifications) {
                input.certifications = [];
            }


            return input;
        }
        validateEducation() {
            // if (!this.schools?.length && !this.certifications?.length) {
            //     return false
            // }

            let input = TB.pick(this, ['schools', 'certifications', 'awards']);
            if (!input.schools) {
                input.schools = [];
            }
            if (!input.certifications) {
                input.certifications = [];
            }
            if (!input.awards) {
                input.awards = [];
            }

            return input;
        }

        static schoolValidationRules() {
            return {
                name: 'Missing school name',
                field_of_study: 'Missing field of study'
            }
        }

        static certificationValidationRules() {
            return {
                name: 'Missing certification name',
                earned_at: 'Missing year earned'
            }
        }

        validateWorkHistory() {
            // if (!this.jobs?.length) {
            //     return false
            // }

            let input = TB.pick(this, 'jobs');
            if (!input.jobs) {
                input.jobs = [];
            }

            for (let i in input.jobs) {
                input.jobs[i].is_still_there = input.jobs[i].is_still_there ? '1' : '0';
            }

            return input;
        }

        static jobValidationRules() {
            return {
                employer: 'Missing employer/company name',
                role: 'Missing role or title'
            }
        }

        validatePortfolio() {
            // if (!this.key_clients?.length) {
            //     return false
            // }

            let input = TB.pick(this, ['key_clients']);

            if (!input.key_clients) {
                input.key_clients = [];
            }
            //     'key_clients.*.disciplines.*.id' => 'nullable|integer|exists:talent_disciplines,id',
            //     'key_clients.*.skills.*.id' => 'nullable|integer|exists:talent_skills,id',
            //     'key_clients.*.industries.*.id' => 'nullable|integer|exists:client_industries,id',
            //     'key_clients.*.brands.*.id, domain, name,icon,is_custom, id'        => 'nullable|string',
            //     'key_clients.*.assets.*.id, content_type, path, caption, display_index'            => 'nullable|integer|exists:assets,id',
            //     'key_clients.*.links'      => 'nullable|array',
            //     'key_clients.*.headline'        => 'required|string|max:255',
            //     'key_clients.*.year'            => 'required|integer|max:'.now()->year.'|min:1950',
            //     'key_clients.*.image_path'     => 'nullable|image_or_string',
            //     'key_clients.*.description'     => 'nullable|string|max:10000',
            //     'key_clients.*.display_index'   => 'nullable|integer',
            input.key_clients = TB.map(input.key_clients, client => {
                let tagTypes = ['disciplines', 'skills', 'industries']
                let formatted = TB.pick(client, [
                    'id',
                    ...tagTypes,
                    'brands',
                    'assets',
                    'links',
                    'headline',
                    'year',
                    'image_path',
                    'description',
                    'display_index',
                ]);
                TB.map(tagTypes, type => {
                    formatted[type] = TB.map(formatted[type] || [], item => TB.pick(item, ['id']))
                })
                formatted.brands = TB.map(formatted.brands || [], item => TB.pick(item, ['id', 'path','domain', 'name','icon','is_custom']))
                formatted.assets = TB.map(formatted.assets || [], (item, index) => {
                    // if (item.originFileObj instanceof File) {
                    //     return {
                    //         path: item.originFileObj,
                    //         content_type: item.content_type || 'PDF',
                    //         caption: item.caption || '',
                    //         display_index: item.display_index
                    //     }
                    // }
                    return TB.pick(item, ['id', 'content_type', 'path','caption','display_index'])
                })

                return formatted
            })
            return input;
        }

        validateAwards() {
            if (!this.awards?.length) {
                return {awards: []}
            }

            return TB.pick(this, 'awards');
        }

        static awardValidationRules() {
            return {
                name: 'Missing award name',
                year: 'Missing year achieved'
            }
        }

        resumeDocument() {

            if (!this.resume_path) {
                return false;
            }

            let resume = this.resume_path;
            if (!(resume instanceof Document)) {
                let displayName = (this.firstNamePlusInitial?.() || '');
                if (displayName.length) displayName += ' - ';
                displayName += 'Resume';
                resume = Document.make({
                    ...resume,
                    name: resume?.name || displayName
                });
            }
            return resume;
        }

        static getResumeImportsForUser(userId) {
            let resumeImports = false;

            try {
                let storedImports = window.localStorage.getItem('resume_imports');

                if (storedImports) {
                    resumeImports = JSON.parse(storedImports);
                }

            } catch (e) {
                console.warn("TB.storedImports", e)
            }
            if (parseInt(resumeImports['userId']) !== parseInt(userId)) {
                window.localStorage.removeItem('resume_imports');
                return false;
            }
            return resumeImports;
        }

        static getImportedItemsFromResumeForUser(userId, propName) {
            let resumeImports = this.getResumeImportsForUser(userId)

            return resumeImports[propName]
        }

        canImportResumeItemsForProfile(generatedAccountData = this.generated_account_data) {
            if (!generatedAccountData) {
                return false;
            }
            let availableItems = this.availableProfileItemsForResumeImport(generatedAccountData);
            return TB.keys(availableItems)?.length;
        }
        canImportResumeItemsForApplication(generatedAccountData = this.generated_account_data) {
            if (!generatedAccountData) {
                return false;
            }
            let availableItems = this.availableApplicationItemsForResumeImport(generatedAccountData);
            return TB.keys(availableItems)?.length;
        }

        availableProfileItemsForResumeImport(generatedAccountData = this.generated_account_data) {
            let allItems = this.availableItemsForResumeImport(generatedAccountData);
            let itemsAvailable = [
                'jobs',
                'schools',
                'certifications',
                'awards',
                'profile_links'
            ];
            let availableItems = {}
            for (let item of itemsAvailable) {
                availableItems[item] = allItems[item];
            }

            return availableItems
        }

        availableApplicationItemsForResumeImport(generatedAccountData = this.generated_account_data) {
            let availableItems = this.availableItemsForResumeImport(generatedAccountData);
            let itemsNotAvailable = [
                'jobs',
                'schools',
                'certifications',
                'awards',
                'profile_links'
            ];
            for (let item of itemsNotAvailable) {
                delete availableItems[item];
            }
            return availableItems
        }

        availableItemsForResumeImport(generatedAccountData = this.generated_account_data) {
            let resumeImports = generatedAccountData || this.constructor.getResumeImportsForUser(this.id);
            if (!resumeImports) {
                return false;
            }
            let applicationFieldsImport = [
                'linkedin_profile_url',
                'years_of_experience',
                'bio',
                'project_interest'
            ];
            let applicationItemsImport = [
                'services',
                'skills',
                'industries_worked',
                'talent_disciplines',
                'disciplines',
                'jobs',
                'schools',
                'certifications',
                'awards',
                'profile_links'
            ]

            let resumeData = {};
            TB.map(applicationFieldsImport, field => {
                if (resumeImports?.[field]?.length > 0) {
                    resumeData[field] = resumeImports[field]
                }
            })
            TB.map(applicationItemsImport, itemField => {
                if (TB.isArray(resumeImports?.[itemField]) && resumeImports?.[itemField]?.length > 0) {
                    let items = resumeImports[itemField];
                    if (itemField === 'skills' ||
                        itemField === 'industries_worked' ||
                        itemField === 'services' ||
                        itemField === 'disciplines' ||
                        itemField === 'talent_disciplines'
                    ) {
                        let lookup = 'id';
                        let authLookup = itemField;
                        if (itemField?.includes('disciplines')) {
                            lookup = 'discipline_id';
                            authLookup = 'talent_disciplines';
                        }
                        if (itemField?.includes('service')) {
                            authLookup = 'talent_service_groups';
                        }
                        let existingItemIds = TB.map(this[authLookup] || [], 'id');

                        items = TB.filter(items, item => !existingItemIds.includes(item[lookup]));
                    }
                    resumeData[itemField] = items;
                }
            })

            console.log('availableItemsForResumeImport', {resumeData, resumeImports})
            return resumeData;
        }

        async syncResumeImportLocalStorage(props) {
            // console.log('TB @ persistStoredPreferences -> store', store);
            let resumeImports = this.constructor.getResumeImportsForUser(this.id) || {
                userId: this.id
            };

            try {
                let updates = TB.reduce(props, (result, value, key) => {
                    // Ignore if value is not array of items
                    if (!Array.isArray(value)) {
                        result[key] = {
                            did_confirm: false
                        }
                        return result;
                    }

                    // reset confirmation for each item
                    result[key] = TB.map(TB.filter(value || [], item => !!item.id), item => {
                        return {
                            id: item.id,
                            did_confirm: false
                        }
                    })
                    return result;
                }, {});

                let imports = TB.merge({...resumeImports}, {...updates});

                window.localStorage.setItem('resume_imports', JSON.stringify(imports));
                console.warn("Storing resume imports")

            } catch (e) {
                console.warn("Error storing preferences", e)
                return false;
            }

            return true;
        }

        importedItemFromResume(propName, item) {
            // console.log('TB @ persistStoredPreferences -> store', store);
            let resumeImports = this.constructor.getImportedItemsFromResumeForUser(this.id, propName)

            // console.log('importedItemFromResume', resumeImports, item)
            return TB.find(resumeImports || [], existing => {
                return !TB.isNaN(parseInt(item?.id)) && parseInt(existing?.id) === parseInt(item?.id)
            });
        }

        async updateTalentVideoInterviewSteps(steps) {
            await TB.queryClient.setQueryData(['fetchLatestVideoInterviewForTalent'], steps);
            let updates = {
                talent_video_interviews: TB.map(TB.filter(steps, step => !!step.latest_interview), step => {
                    let {latest_interview, ...stepProps} = step || {}
                    return {
                        ...latest_interview,
                        step: stepProps
                    }
                })
            }
            try {
                await Auth.update(User.make({
                    ...this,
                    ...updates
                }))
            } catch (e) {
                console.error(e);
            }
            return updates;
        }

        hasCompletedVideoInterview() {
            return !TB.find(laravel.talent_video_interview_steps, step => {
                return !TB.find(this.talent_video_interviews || [], ['step.id', step?.id])
            })
        }

        /*
        |--------------------------------------------------------------------------
        | Talent User Work Preferences
        |--------------------------------------------------------------------------
        */
        static TalentWorkPreferences = [
            'project_short_length',
            'project_long_length',
            'project_full_time',
            'client_startup',
            'client_mid_size',
            'client_large',
            'project_team',
            'project_individual',
            'contract_fixed_fee',
            'contract_time_materials'
        ]

        static GroupedTalentWorkPreferences = [
            {
                'Length of assignment:': [
                    {label: 'Short (< 1 month)', key: 'project_short_length'},
                    {label: 'Medium (1-3 months)', key: 'project_long_length'},
                    {label: 'Long (> 3 months)', key: 'project_full_time'}
                ],
                'Company size:': [
                    {label: 'Start-Ups', key: 'client_startup'},
                    {label: 'Mid-Sized', key: 'client_mid_size'},
                    {label: 'Large', key: 'client_large'},
                ]
            },
            {
                'Individual vs. Team:': [
                    {
                        label: 'Team-Based Projects',
                        subLabel: 'Be part of a cross-discipline freelance team curated by Wripple.',
                        key: 'project_team'
                    },
                    {
                        label: 'Individual Projects',
                        subLabel: 'Individual staffing assignments that require your expertise.',
                        key: 'project_individual'
                    }
                ],
                'Contract Structure:': [
                    {label: 'Fixed Price', key: 'contract_fixed_fee'},
                    {label: 'Time and Materials', key: 'contract_time_materials'}
                ]
            }]

        talentPreferences() {
            let preferences = TB.pick(this, [
                'talent_commitment_level',
                'available_hours_per_week',
                'has_full_time_employment_interest',
                'has_contract_to_hire_interest',
                'can_travel_for_work',
                'prefers_any_non_us_timezone',
                'prefers_any_timezone',
                'is_available',
                'travel_days_per_week',
                'max_travel_distance',
                'max_travel_distance_units',
            ])
            let workPreferenceRatings = this.constructor.TalentWorkPreferences;

            workPreferenceRatings = TB.reduce(workPreferenceRatings, (result, rating) => {
                result[rating] = parseInt(this.talent_work_preferences?.[rating]) || 1;
                return result;
            }, {})

            let allTimeZones = Object.values({...laravel.talent_questions.time_zones});

            let timeZonePrefs = {};
            for (let timeZone of allTimeZones) {
                timeZonePrefs[timeZone.id] = this.prefers_any_timezone
                    || this.time_zones.includes(timeZone.id);
            }

            return {
                ...preferences,
                selected_time_zones: timeZonePrefs,
                talent_work_preferences: {...workPreferenceRatings}
            }
        }

        /*
        |--------------------------------------------------------------------------
        | Talent User Requests
        |--------------------------------------------------------------------------
        */
        static GetTalentUserStatsRequest;

        async getTalentUserStats() {
            if (!this.isAuthUser()) {
                return false;
            }

            if (!this.isProfileApproved()) {
                return false;
            }
            if (this.constructor.GetTalentUserStatsRequest?.isRunning()) {
                await this.constructor.cancelRequest('GetTalentUserStatsRequest');
            }

            this.constructor.GetTalentUserStatsRequest = TB.request(
                TB.api_endpoint(`/api/talent-dashboard`)
            )

            let response = await this.constructor.GetTalentUserStatsRequest.get()
                .catch(console.warn);

            if (!response || !TB.has(response, 'success.data')) {
                return false;
            }

            return response.success.data;
        };


        static FetchCoverLetters;

        static async fetchCoverLettersForTalent(requestOptions = {}, params = {}) {
            let auth = TB.auth().user()
            if (!auth) {
                throw new Error('Unauthenticated')
            }
            if (!auth.isTalent() && !auth.canManageClientResourceTalent()) {
                throw new Error('Unauthorized')
            }

            if (this.FetchCoverLetters?.isRunning()) {
                await this.cancelRequest('FetchCoverLetters');
            }

            this.FetchCoverLetters = TB.request(
                TB.api_endpoint(`/api/talent-project-positions/cover-letters/history`),
                params
            )

            let response = await this.FetchCoverLetters.get(requestOptions).catch(console.warn);

            if (!response || !TB.has(response, 'success.data.cover_letters')) {
                throw new Error("Something went wrong")
            }

            return response.success.data.cover_letters
        };
        static FetchJobs;

        static async fetchJobsForTalent(params = {}, requestOptions = {}) {
            let auth = TB.auth().user()
            if (!auth) {
                throw new Error('Unauthenticated')
            }
            if (!auth.isTalent() && !auth.canManageClientResourceTalent()) {
                throw new Error('Unauthorized')
            }

            if (this.FetchJobs?.isRunning()) {
                await this.cancelRequest('FetchJobs');
            }

            this.FetchJobs = TB.request(
                TB.api_endpoint(`/api/talent-project-positions`),
                params
            )

            let response = await this.FetchJobs.post(requestOptions)
                .catch(console.warn);

            if (!response || !TB.has(response, 'success.data.project_positions')) {
                throw new Error("Something went wrong")
            }
            let {
                project_positions,
                current_page,
                last_page,
                total,
                favorites_total,
                archived_total,
                matches_total,
            } = response.success.data;

            return {
                jobs: ProjectPosition.makeMany([...project_positions]),
                current_page,
                last_page,
                total,
                favorites_total,
                archived_total,
                matches_total,
            }
        };

        static FetchJobDetails;

        static async fetchJobDetailsForTalent(positionId, requestOptions = {}) {
            let auth = TB.auth().user()
            if (!auth) {
                throw new Error('Unauthenticated')
            }
            if (!auth.isTalent() && !auth.canManageClientResourceTalent()) {
                throw new Error('Unauthorized')
            }

            if (this.FetchJobDetails?.isRunning()) {
                await this.cancelRequest('FetchJobDetails');
            }

            this.FetchJobDetails = TB.request(
                TB.api_endpoint(`/api/talent-project-positions/${positionId}`)
            )

            let response = await this.FetchJobDetails.get(requestOptions).catch(console.warn);

            if (this.FetchJobDetails.didFinish && this.FetchJobDetails.statusCode() === 404) {
                return false
            }
            if (!response || !TB.has(response, 'success.data.project_position')) {
                throw new Error("Something went wrong")
            }
            let job = response.success.data.project_position;

            if (job.matching_talent) {
                job.matching_talent = User.makeMany(job.matching_talent)
            }
            return ProjectPosition.make(job);
        };

        static ToggleInterestForJobRequest;
        static ProposeInterestForJobRequest;

        async proposeInterestForJob(job = {}, params = {}) {
            console.log('HasTalentTraits @ proposeInterestForJob', job, params)
            if (!job.has_shown_interest_in_job && !job?.can_show_interest_in_job) {
                return false;
            }

            let auth = TB.auth().user()
            if (!auth) {
                return false;
            }
            if (!auth.canManageClientResourceTalent() && !auth.isTalent()) {
                return false
            }
            if (auth.canManageClientResourceTalent() && !params.talent_user_id) {
                return false;
            }

            if (this.constructor.ProposeInterestForJobRequest?.isRunning()) {
                await this.constructor.cancelRequest('ProposeInterestForJobRequest');
            }

            let jobId = job?.id
            if (job.project_position?.id) {
                jobId = job.project_position.id;
            }

            // this.constructor.ProposeInterestForJobRequest = TB.request(
            //     TB.api_endpoint(
            //         `/api/talent-project-positions/${jobId}/propose-interest`
            //     ), params
            // )
            //
            //
            // let response = await this.constructor.ProposeInterestForJobRequest.post()
            //     .catch(console.warn);
            //
            // if (!response || (!TB.has(response, 'success.data'))) {
            //     return false;
            // }
            // if (!response.success.data?.opportunity) {
            //     return false;
            // }
            //
            // let {
            //     position_deliverables,
            //     ...data
            // } = response.success.data?.opportunity;

            let {
                client,
                project,
                ...project_position
            } = job;
            let opportunity = {

                project_position,
                project,
                client,
                is_fixed_retainer_contract: job.isFixedRetainer(),
                is_fixed_fee_contract: job.isFixedFee(),
                job_candidate: {
                    // ...data,
                    talent_opps: [{
                        // ...data, position_deliverables
                    }]
                }
            }
            if (opportunity && opportunity.is_agency_opp) {
                return AgencyOpportunity.make(opportunity)
            }

            return Opportunity.make(opportunity)
        };

        async toggleInterestForJob(job = {}, params = {}) {
            console.log('HasTalentTraits @ toggleInterestForJob', job, params)
            if (!job.has_shown_interest_in_job && !job?.can_show_interest_in_job) {
                return false;
            }

            let auth = TB.auth().user()
            if (!auth) {
                return false;
            }
            if (!auth.canManageClientResourceTalent() && !auth.isTalent()) {
                throw new Exception("Something went wrong")
            }
            if (auth.canManageClientResourceTalent() && !params.talent_user_id) {
                throw new Exception("Something went wrong")
            }

            if (this.constructor.ToggleInterestForJobRequest?.isRunning()) {
                await this.constructor.cancelRequest('ToggleInterestForJobRequest');
            }

            let jobId = job?.id
            if (job.project_position?.id) {
                jobId = job.project_position.id;
            }

            this.constructor.ToggleInterestRequest = TB.request(
                TB.api_endpoint(
                    `/api/talent-project-positions/${jobId}/${!job.has_shown_interest_in_job ? 'show' : 'remove'}-interest`
                ), params
            )


            let response = await this.constructor.ToggleInterestRequest.post()
                .catch(console.warn);

            if (!response || (!TB.has(response, 'success.data'))) {
                return false;
            }

            let {
                project_position,
                opportunity
            } = {...response.success.data};

            if (!project_position && !opportunity) {
                return false;
            }

            if (opportunity && opportunity.is_agency_opp) {
                return AgencyOpportunity.make(opportunity)
            }

            if (project_position) {
                return ProjectPosition.make(project_position)
            }

            return Opportunity.make(opportunity)
        };

        static UpdateForProjectPositionMatchingRequest;

        async updateForProjectPositionMatching(position, props = {}) {
            let position_id = position;
            if (TB.isObject(position)) {
                position_id = position.id
            }

            if (
                (TB.isObject(position) && !position?.is_match) || this.id !== TB.auth().user().id ||
                !TB.auth().user()?.isTalent()) {
                return false;
            }

            if (this.constructor.UpdateForProjectPositionMatchingRequest?.isRunning()) {
                await this.constructor.cancelRequest('UpdateForProjectPositionMatchingRequest');
            }

            let updateProps = {};

            if (props.skills?.length) {
                let skills = this.skills || [];

                let skillsToAdd = props.skills || [];
                skills = TB.filter([...skills], skill => !TB.includes(TB.map(skillsToAdd, 'id'), skill.id));

                updateProps.skills = TB.map([
                    ...skills,
                    ...skillsToAdd
                ], skill => {
                    let item = TB.pick(skill, ['id', 'self_score'])
                    item.self_score = parseInt(item.self_score)
                    return item
                });

            }
            if (props.industries?.length) {
                let industries_worked = this.industries_worked || [];

                let industries = props.industries || [];
                industries_worked = TB.filter(industries_worked, industry => !TB.includes(TB.map(industries, 'id'), industry.id));

                updateProps.industries_worked = TB.map([
                    ...industries_worked,
                    ...industries
                ], industry => {
                    let item = TB.pick(industry, ['id', 'self_score'])
                    item.self_score = parseInt(item.self_score)
                    return item
                });
            }

            if (props.disciplines?.length) {
                let talent_disciplines = this.talent_disciplines || [];

                let disciplines = props.disciplines || [];
                talent_disciplines = TB.filter(talent_disciplines, discipline => !TB.includes(TB.map(disciplines, 'id'), discipline.id));

                updateProps.talent_disciplines = TB.map([
                    ...talent_disciplines,
                    ...disciplines
                ], dis => {
                    let item = TB.pick(dis, ['id', 'self_score'])
                    item.self_score = parseInt(item.self_score)
                    return item
                });
            }

            if (props.brands?.length) {
                let talent_brands = this.brands || [];

                let brands = props.brands || [];

                let lastIndex = TB.max(TB.map(talent_brands, 'display_index')) || 1;
                console.log('updateForProjectPositionMatching', lastIndex)
                updateProps.brands = TB.map([
                    ...talent_brands,
                    ...brands
                ], brand => {
                    if (TB.isNaN(parseInt(brand.display_index))) {
                        lastIndex +=1;
                        return {
                            ...brand,
                            display_index: lastIndex
                        }
                    }

                    return brand
                });
                console.log('updateForProjectPositionMatching', updateProps.brands)
            }


            this.constructor.UpdateForProjectPositionMatchingRequest = TB.request(
                TB.api_endpoint(`/api/talent-project-positions/${position_id}/update-matching`),
                updateProps
            )

            let response = await this.constructor.UpdateForProjectPositionMatchingRequest.post()
                .catch(console.warn);

            if (!response || !TB.has(response, 'success.data.project_position')) {
                return false;
            }
            if (TB.has(response, 'success.data.auth')) {
                await TB.auth().update(this.constructor.make({...response.success.data.auth}))
            }

            return ProjectPosition.make({...response.success.data.project_position})
        };


        /*
        |--------------------------------------------------------------------------
        | Talent User Last Updates
        |--------------------------------------------------------------------------
        */


        shouldRemindForPreferencesResumeUpdate() {
            let preferencesUpdate = this.lastUpdatedWorkPreferences(false, true);

            return !this.resumeDocument() ||
                TB.moment().utc().endOf('day').subtract(30, 'days').isAfter(preferencesUpdate)
        }
        // - latest_updates: {
        //         : "2021-08-19T12:21:06+00:00",
        //         : "2021-08-19T12:21:06+00:00",
        //         : "2021-08-19T12:21:10+00:00",
        //         : "2021-08-19T12:21:06+00:00",
        //         : "2020-07-08T00:01:31+00:00",
        //         : "2021-08-19T15:36:02+00:00",
        //         : "2021-08-19T12:21:16+00:00",
        //         : "2021-08-19T12:21:16+00:00",
        //         : "2021-08-19T12:21:15+00:00",
        //         : "2021-08-19T15:25:11+00:00",
        //         : "2021-08-19T12:21:06+00:00",
        //         : "2021-08-19T12:21:06+00:00"
        //     },

        getLastUpdated(key, formatted) {
            if (!this.isAuthUser() || !this.latest_updates?.[key]) {
                return false;
            }

            let updatedAt = TB.moment(this.latest_updates[key]);
            if (!updatedAt.isValid()) {
                return false;
            }

            let days = Math.abs(updatedAt.diff(TB.moment(), 'days'));

            if (days < 0) return 0;

            if (!formatted) return days;

            let format = days + ' day';
            if (days > 1) {
                format += 's';
            }
            return format;
        }

        lastUpdatedInfo(formatted = false, keyOnly = false) {
            const key = 'profile_basic';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedBio(formatted = false, keyOnly = false) {
            const key = 'profile_bio';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedSkills(formatted = false, keyOnly = false) {
            const key = 'profile_roles_skills';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedProjectInterests(formatted = false, keyOnly = false) {
            const key = 'profile_project_interests';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedIndustries(formatted = false, keyOnly = false) {
            const key = 'profile_industry_exp';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }
        lastUpdatedReferences(formatted = false, keyOnly = false) {
            const key = 'profile_talent_references';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedBrands(formatted = false, keyOnly = false) {
            const key = 'profile_brands';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }


        lastUpdatedLinksDocs(formatted = false, keyOnly = false) {
            const key = 'profile_links_docs';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedEducation(formatted = false, keyOnly = false) {
            const key = 'profile_education';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedWorkHistory(formatted = false, keyOnly = false) {
            const key = 'profile_work_history';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedPortfolio(formatted = false, keyOnly = false) {
            const key = 'profile_portfolio';
            if (keyOnly && this.latest_updates) return this.latest_updates[key]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedAwards(formatted = false, keyOnly = false) {
            const key = 'profile_awards';
            if (keyOnly && this.latest_updates) return this.latest_updates[keyOnly]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedWorkStatus(formatted = false, keyOnly = false) {
            const key = 'dashboard_availability';
            if (keyOnly && this.latest_updates) return this.latest_updates[keyOnly]
            return this.getLastUpdated(key, formatted)
        }

        lastUpdatedWorkPreferences(formatted = false, keyOnly = false) {
            const key = 'profile_work_preferences';
            if (keyOnly && this.latest_updates) return this.latest_updates[keyOnly]
            return this.getLastUpdated(key, formatted)
        }

        isTalentSupplierResource() {
            return TB.isObject(this.supplier_client)
        }

        isClientInvitedResource(params) {
            if (TB.isDefined(params?.is_on_talent_marketplace)) { // type of boolean
                return this.client_invites_received?.length > 0 && this.is_on_talent_marketplace === params.is_on_talent_marketplace
            }
            return this.client_invites_received?.length > 0
        }

        isOnTalentMarketplace() {
            return !this.isClientInvitedResource() || this.is_on_talent_marketplace
        }

        canViewTalentOppMessages() {
            return !this.isTalentSupplierResource()
        }

        canViewTalentOppInterviews() {
            return true
        }

        canManageTalentOppInterviews() {
            return !this.isTalentSupplierResource()
        }
    }
}

export default HasTalentTraits